<template>
  <div class="content">
    <div class="image-text_1 flex-row justify-between">
      <div class="box_8 flex-col"></div>
      <span class="text-group_1">概貌剪影</span>
      <div class="group_2 flex-col"></div>
    </div>
    <div class="honors">
      <div v-for="(item, index) in overviewList" >
        <div class="container">
          <div class="list-items_1-0 flex-col" >
            <img class="list-items_1-0-img" :src="item.fileUrl" @click="openUrl(item.fileUrl)">
          </div>
        </div>
      </div>

    </div>
    <div class="block_5 flex-row">
      <Pagination v-show="total>0" :total="total" :background="false" :page.sync="params.pageIndex" :limit.sync="params.pageSize"
                  @pagination="getData"/>
    </div>
  </div>
</template>

<script>
import Pagination from './Pagination'
export default {
  components: { Pagination },
  name: "OverviewSilhouette",
  data() {
    return {
      params:{
        pageIndex:1,
        pageSize:4,
      },
      total:28,
      overviewList: [
        {"title": "创业阶段创业阶段创业阶段创业阶段创业阶段"},
        {"title": "创业阶段（1996-1999）"},
        {"title": "创业阶段（1996-1999）"},
        {"title": "创业阶段（1996-1999）"},
      ]
    }
  },
  methods:{
    openUrl(url){
      window.open(url);
    },
    //获取概貌剪影列表
    getData() {
      var _this = this;
      _this.$api.post(
          "/Client/getOverviewSilhouette",
          {pageSize:_this.params.pageSize,pageIndex:_this.params.pageIndex},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              _this.overviewList = res.data;
            }
          }
      );
    },
  },
  mounted() {
    let that = this;
    that.getData();
  },
}
</script>

<style scoped>
.container {
  width: 530px;
  height: 280px;
  display: grid;
  place-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
  transition: ease-in .3s;

  background: linear-gradient(0, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-90deg, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-180deg, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-270deg, #005AD6 4px, #005AD6 4px) no-repeat;

  background-size: 0 2px, 2px 0, 0 2px, 2px 0;

  background-position: left top, right top, right bottom, left bottom;

}

.container:hover {

  background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;

}

.list-items_1-0-img{
  width: 526px;
  height: 276px;
  transition: all 0.3s;
  cursor: pointer;
}
.list-items_1-0-img:hover{
  transform: scale(1.1);
  max-width: 100%; /* 设置最大宽度为原始图片宽度，防止超出 */
  max-height: 100%; /* 设置最大高度为原始图片高度，防止超出 */
}
.list-items_1-0{
  width: 526px;
  height: 276px;
  background: #F3FBFF;
  display: grid;
  place-items: center;
  overflow: hidden; /* 隐藏超出容器范围的内容 */
}
.content{
  width: 1120px;
  position: relative;
}
.block_5 {
  height: 22px;
  position: absolute;
  right: 0;
  bottom: -98px;
}
.honors{
  width: 1120px;
  height: 600px;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 0px;
  grid-auto-rows: 0;
  margin-top: 120px;
  margin-left: 15px;
}
.image-text_1 {
  width: 141px;
  height: 48px;
  position: relative;
  top: 88px;
}
.text-group_1 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}
.group_2 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.box_8 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
  margin-left: 485px;
}
</style>

<style  lang="less" scoped>
/deep/ .snap-list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  position: relative;
  left: -50px;
  .line {
    border-bottom: 1px solid rgb(36, 155, 255);
    width: 595px;
    position: absolute;
    top: 18px;
  }
  .el-timeline {
    margin-left: 650px;
    width: 595px;
    padding-left: 0px;
  }
  .timeline-icon-z {
    background: url('../../../../assets/aboutSailHero/img/z.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    right: 0;
    top: 53px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .timeline-icon-y {
    background: url('../../../../assets/aboutSailHero/img/y.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    left: 0px;
    top: 48px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .el-timeline-item {
    padding-bottom: 10px;
    .el-timeline-item__node--normal{
      display: none;
      margin-top: 45px;
    }
    .el-timeline-item__wrapper{
      padding-left: 43px;
      .el-timeline-item__content {
        color: #076EF1;
        font-size: 20px;
      }
      .el-timeline-item__timestamp {
        width: 550px;
        margin-top: 12px;
      }
      .el-timeline-item__timestamp.is-top{
        margin-bottom: -4px;
      }
    }
    .el-timeline-item__tail {
      border-left: 1px solid #005AD6;
      left: 0px;
      margin-top: 10px;
      height: 120%;
    }
    .el-timeline-item__node--large {
      width:14px;
      height: 14px;
      margin-top: 6px;
    }
  }
}
/deep/ .el-timeline-item-live-out{
  .el-timeline-item__wrapper{
    left: -595px;
  }
}
/deep/ .el-timeline-item-live-even{
  .el-timeline-item__wrapper{
    text-align: left;
  }
}
/deep/ .el-card{
  border: 0px solid #EBEEF5;
}
</style>
